import React from "react";

export function CloseButtonIcon(): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      viewBox="0 0 52 52"
      filter="drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.3))"
    >
      <g id="Group_4" data-name="Group 4" transform="translate(-22 -27)">
        <circle
          id="Ellipse_39"
          data-name="Ellipse 39"
          cx="26"
          cy="26"
          r="26"
          transform="translate(22 27)"
          fill="#fff"
        />
        <g id="x" transform="translate(25 31)">
          <g
            id="Group_2482"
            data-name="Group 2482"
            transform="translate(-1013 -118)"
          >
            <line
              id="Line_211"
              data-name="Line 211"
              x2="23"
              y2="23"
              transform="translate(1025 130)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <line
              id="Line_212"
              data-name="Line 212"
              x1="21.949"
              y2="22.98"
              transform="translate(1025 130)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeWidth="2"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
